export default __webpack_public_path__ + "media/images/images/logo/logo-e3113165e2681a4c7498658c4f94df06.png";